export enum ErrorException {
  SCHEMA_VALIDATOR_EXCEPTION = 'SchemaValidatorException',
}
